var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderCartHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Cart, Property 2=Hover",
    clipPath: "url(#clip0_828_1439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1858 28.9961C11.8887 28.9961 12.4585 28.4206 12.4585 27.7106C12.4585 27.0006 11.8887 26.425 11.1858 26.425C10.4829 26.425 9.91309 27.0006 9.91309 27.7106C9.91309 28.4206 10.4829 28.9961 11.1858 28.9961Z",
    fill: "white",
    stroke: "#EC187B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.1824 29C25.8853 29 26.4551 28.4245 26.4551 27.7145C26.4551 27.0045 25.8853 26.4289 25.1824 26.4289C24.4795 26.4289 23.9097 27.0045 23.9097 27.7145C23.9097 28.4245 24.4795 29 25.1824 29Z",
    fill: "white",
    stroke: "#EC187B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1 1H6.09091L9.50182 18.8529C9.6182 19.4667 9.93697 20.0181 10.4023 20.4106C10.8677 20.803 11.45 21.0115 12.0473 20.9995H24.4182C25.0155 21.0115 25.5978 20.803 26.0631 20.4106C26.5285 20.0181 26.8473 19.4667 26.9636 18.8529L29 7.6665H7.36364",
    stroke: "#EC187B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter0_d_828_1439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4025 20.4106C9.93711 20.0181 9.61834 19.4667 9.50195 18.8529L7.36377 7.6665H29.0001L26.9638 18.8529C26.8474 19.4667 26.5286 20.0181 26.0633 20.4106C25.5979 20.803 25.0156 21.0115 24.4183 20.9995H12.0474C11.4501 21.0115 10.8678 20.803 10.4025 20.4106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4025 20.4106C9.93711 20.0181 9.61834 19.4667 9.50195 18.8529L7.36377 7.6665H29.0001L26.9638 18.8529C26.8474 19.4667 26.5286 20.0181 26.0633 20.4106C25.5979 20.803 25.0156 21.0115 24.4183 20.9995H12.0474C11.4501 21.0115 10.8678 20.803 10.4025 20.4106Z",
    stroke: "#EC187B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_828_1439",
    x: 3.75928,
    y: 4.1665,
    width: 28.8403,
    height: 20.3335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.0941176 0 0 0 0 0.482353 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_828_1439"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_828_1439",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_828_1439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCartHover);
export default __webpack_public_path__ + "static/media/headerCartHover.0ccfeb23b9451406e382c3881a4f0dca.svg";
export { ForwardRef as ReactComponent };